import { PLANNER_BASE_PATH } from './plannerBasePath.constants.tsx';

/**
 * The planner's origin, when it is served from a different origin than Jira.
 * Returns `null` when the planner is same-origin (the relative `/planner` base),
 * in which case preconnecting is unnecessary. Used to warm the connection
 * (preconnect) before the iframe mounts.
 */
export const getAiPlannerOrigin = (): string | null => {
	try {
		// An absolute base has an origin distinct from a relative path.
		const url = new URL(PLANNER_BASE_PATH, 'https://relative.invalid');
		return url.origin === 'https://relative.invalid' ? null : url.origin;
	} catch {
		return null;
	}
};
